var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutorefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5,8 C4.72385763,8 4.5,7.77614237 4.5,7.5 C4.5,7.22385763 4.72385763,7 5,7 L7,7 L7,4 C7,3.72385763 7.22385763,3.5 7.5,3.5 C7.77614237,3.5 8,3.72385763 8,4 L8,8 L5,8 Z M11.9725356,8 C11.9906833,7.83583307 12,7.66900455 12,7.5 C12,5.01471863 9.98528137,3 7.5,3 C5.01471863,3 3,5.01471863 3,7.5 C3,9.98528137 5.01471863,12 7.5,12 C8.74356117,12 9.8693073,11.4955739 10.6837897,10.6801703 L12.0989572,12.0934294 C10.9224709,13.2713226 9.29633129,14 7.5,14 C3.91014913,14 1,11.0898509 1,7.5 C1,3.91014913 3.91014913,1 7.5,1 C11.0898509,1 14,3.91014913 14,7.5 C14,7.668236 13.9936085,7.83497919 13.9810552,8 L16,8 L13,10.9959542 L10,8 L11.9725356,8 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutorefresh);
export default __webpack_public_path__ + "static/media/autorefresh.39a86d1d88a228736cfae725e4d4edd6.svg";
export { ForwardRef as ReactComponent };